export default __webpack_public_path__ + "locales/az/SendInviteDialog.json?hash=01c63eb5392757b7b9734601ac246a57";